import { BAILocale } from '.';
import pl_PL from 'antd/es/locale/pl_PL';

const localeValue: BAILocale = {
  lang: 'pl',
  antdLocale: pl_PL,
};

export default localeValue;
